import { FormControl } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'

import { StatusCheckNameFieldInput } from 'components/status-checks/form/status-check/common/StatusCheckNameFieldInput'
import { type StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'

export const StatusCheckNameField = () => {
  const { control } = useFormContext<StatusCheckFormValues>()

  return (
    <FormControl>
      <Controller
        control={control}
        name="statusCheckName"
        render={StatusCheckNameFieldInput}
      />
    </FormControl>
  )
}
